module.exports = __webpack_public_path__ + "img/locate-me.f0433ccc.png";